// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BillingProductAccessGuard-module__spinner--IAMtXEis{display:flex;justify-content:center;margin-top:48px;width:100%}", "",{"version":3,"sources":["webpack://./src/features/billingProductAccessGuard/ui/BillingProductAccessGuard/BillingProductAccessGuard.module.scss"],"names":[],"mappings":"AAAA,qDACE,YAAA,CACA,sBAAA,CACA,eAAA,CACA,UAAA","sourcesContent":[".spinner {\n  display: flex;\n  justify-content: center;\n  margin-top: 48px;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinner": "BillingProductAccessGuard-module__spinner--IAMtXEis"
};
export default ___CSS_LOADER_EXPORT___;
